<template>
    <section class="home-contest">
       
      <div class="container section-contest section-value-props hidden">
        <div class="section-data">
          <div class="section-header">
            <!-- <span class="subheading">{{$t('contests.title')}}</span> -->
            
            <h2 class="heading-secondary">Your Learning Journey</h2>
            <img src="/assets/invrs-why2.png" class="value-icon-2" >
            <p class="value-description">
          At INVRS, we’ve designed our Foundation Course to teach you everything you need to start your investing journey. 
            </p>
            <p class="value-description">It covers the essentials - fraud awareness, how to place trades (using our simulator), and the core principles of long-term investing. 
            </p>
            <!-- <p class="value-description">It ends with a reflection to help you decide your next step.
          </p> -->
          <p class="value-description">Your next stop is Portfolio Management, because it’s all about the portfolio.
            </p>
            <p class="value-description">
From there, you can branch into:
<ul style="margin-left:5rem;" class="value-description">
<li>Stock Picking — practical techniques to evaluate companies.</li>
<li>Bond Strategies — what these often-overlooked assets can do for your portfolio.</li>
<li>Options — obtain an in depth understanding of options: how they work, risks and pitfalls, strategies.</li>
<li>Market Expectations — the secret sauce of great investors.</li>
  </ul></p>
<p  class="value-description">
All our courses are set in the context of a story, include skill-testing questions and blend text and video to suit your learning style.
</p>

          </div>

          <div style="margin-top: 3rem;" class="section-header">
            <!-- <span class="subheading">{{$t('contests.title')}}</span> -->
            <h2 class="heading-tertiary">How INVRS Works</h2>
          </div>
          <div class="grid grid--3-cols">
            <div class="value-box hidden">
              <img src="/assets/invrs-contest1.png" class="value-icon" />
              <h3 class="heading-tertiary">Learn Real Strategies</h3>
              <p class="value-description">
                Short, practical lessons set in a story teach you the why and how of investing.
              </p>
            </div>
            <div class="value-box hidden">
              <img src="/assets/invrs-contest2.png" class="value-icon" />
              <h3 class="heading-tertiary" >Practice</h3>
              <p class="value-description" >Use our simulator to test strategies in live market conditions—without risking real money.
              
              </p>
            </div>
            <div class="value-box hidden">
              <img src="/assets/invrs-contest3.png" class="value-icon" />
              <h3 class="heading-tertiary" >Build Confidence</h3>
              <p class="value-description" >Through games and challenges, compete, experiment, and level up your skills.
You’ll earn Playdough—and maybe even win real cash.

              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        valueProps: [],
        obsOptionsValueProps: {
          root: null,
          threshold: 0.3,
        },
        obsOptionsSection: {
          root: null,
          threshold: 0.15,
        },
        section: "",
      };
    },
    mounted() {
      this.valueProps = document.querySelectorAll(".home-contest .value-box");
      this.section = document.querySelector(".home-contest .section-value-props");
      const valuePropsObserver = new IntersectionObserver(
        this.revealValueProps,
        this.obsOptionsValueProps
      );
      const sectionObserver = new IntersectionObserver(
        this.revealSection,
        this.obsOptionsSection
      );
      valuePropsObserver.observe(this.section);
      sectionObserver.observe(this.section);
    },
    methods: {
      revealValueProps(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.valueProps.forEach((v, i) => {
              setTimeout(() => v.classList.remove("hidden"), i * 100);
            });
          }
        });
      },
      revealSection(entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.section.classList.remove("hidden");
          }
        });
      },
    },
  };
  </script>
  
<style scoped>
.heading-secondary{
    font-size: 3rem;
}

section {
  padding: 5rem 0;

  background-color: #32364e;
  /*transform: skewY(3deg); */
  box-shadow: inset 4.8rem 4.8rem 9.6rem #2b2e42,
    inset -4.8rem -4.8rem 9.6rem #3a3e5a;
}
.container{
    /*transform: skewY(-3deg);*/
}
.subheading {
  color: #33cc99;
}

.heading-secondary {
  color: #fff;
}

.heading-tertiary {
    font-size: 2.4rem;
    color: #fff;
    margin-bottom: 0.8rem;
}

.value-description {
  color: #fff;
}

.heading-description {
  line-height: 3.5rem;
  width: 60%;
  color: #f2f4fa;
  margin-bottom: 4.8rem;
}

.section-contest {
  max-width: 180rem;
  transition: all 0.3s ease-in;
}

.section-value-props {
  transition: all 0.3s ease-in;
}

.value-description {
  font-size: 1.8rem;
  line-height: 2.6rem;
}

.value-icon {
  margin-bottom: 1.6rem;
  width: 9.2rem;
  height: 10rem;
}
.value-icon-2{
   margin-bottom: 1rem;
  width: 9rem;

}

.section-header {
  display: flex;
  flex-direction: column;
}

.value-box {
  transition: all 0.3s ease-in;
}

.hidden {
    transform: translateY(4.8rem);
    opacity: 0;
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
    .value-icon {
    margin-bottom: 1.6rem;
    width: 6.4rem;
    height:6.4rem;
    }

    .value-icon-2 {
  
    width: 6.4rem;
   
    }
}
button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 5px 10px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}
  
  </style>
  